<template>
    <div class="d-flex">
        <v-autocomplete v-model="internalValueHours" :items="hours" @change="updateValue" ></v-autocomplete><span style="display: block; min-width: 10px;padding-top: 20px;">:</span><v-autocomplete v-model="internalValueMinutes" :items="minutes" @change="updateValue" ></v-autocomplete>
    </div>
  <!--<v-text-field
    v-bind="$attrs"
    v-on="$listeners"
    :value="internalValue"
    @input="updateValue"
    :label="label"
    :error-messages="errorMessages"
  >
    
  </v-text-field>-->
  
</template>

<script>
export default {
  name: 'CustomInput',
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    rules: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      internalValueHours: '',
      internalValueMinutes: '',
        hours: Array.from({ length: 24 }, (_, i) => i.toString().padStart(2, '0')),
        minutes: Array.from({ length: 60 }, (_, i) => i.toString().padStart(2, '0')),

    };
  },
  watch: {
    value(val) {      
        
      this.internalValueHours = val ? val.split(':')[0] : null;
      this.internalValueMinutes = val ? val.split(':')[1] : null;
    }
  },
//   computed: {
//     errorMessages() {
//       return this.rules
//         .map(rule => (typeof rule === 'function' ? rule(this.internalValue) : true))
//         .filter(result => result !== true);
//     },
//   },
  methods: {
    updateValue(val) {
      //this.internalValue = val;
      let rslt = this.internalValueHours + ':' + this.internalValueMinutes;
      this.$emit('input', rslt); // supports v-model
    },
  },
  created() {
    this.internalValueHours = this.value ? this.value.split(':')[0] : null,
    this.internalValueMinutes = this.value ? this.value.split(':')[1] : null,
    console.log("XYXYXYYXXYXYXYXYX: " + this.value);
  }
};
</script>
